import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-bullet-list-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <path
        d="M9.88889 8.79986H17M9.88889 11.9999H17M9.88889 15.1999H17M7.22222 8.79986H7.22637V8.80474H7.22222V8.79986ZM7.44444 8.79986C7.44444 8.86048 7.42103 8.91862 7.37936 8.96148C7.33768 9.00435 7.28116 9.02843 7.22222 9.02843C7.16329 9.02843 7.10676 9.00435 7.06509 8.96148C7.02341 8.91862 7 8.86048 7 8.79986C7 8.73924 7.02341 8.6811 7.06509 8.63824C7.10676 8.59537 7.16329 8.57129 7.22222 8.57129C7.28116 8.57129 7.33768 8.59537 7.37936 8.63824C7.42103 8.6811 7.44444 8.73924 7.44444 8.79986ZM7.22222 11.9999H7.22637V12.0047H7.22222V11.9999ZM7.44444 11.9999C7.44444 12.0605 7.42103 12.1186 7.37936 12.1615C7.33768 12.2044 7.28116 12.2284 7.22222 12.2284C7.16329 12.2284 7.10676 12.2044 7.06509 12.1615C7.02341 12.1186 7 12.0605 7 11.9999C7 11.9392 7.02341 11.8811 7.06509 11.8382C7.10676 11.7954 7.16329 11.7713 7.22222 11.7713C7.28116 11.7713 7.33768 11.7954 7.37936 11.8382C7.42103 11.8811 7.44444 11.9392 7.44444 11.9999ZM7.22222 15.1999H7.22637V15.2047H7.22222V15.1999ZM7.44444 15.1999C7.44444 15.2605 7.42103 15.3186 7.37936 15.3615C7.33768 15.4044 7.28116 15.4284 7.22222 15.4284C7.16329 15.4284 7.10676 15.4044 7.06509 15.3615C7.02341 15.3186 7 15.2605 7 15.1999C7 15.1392 7.02341 15.0811 7.06509 15.0382C7.10676 14.9954 7.16329 14.9713 7.22222 14.9713C7.28116 14.9713 7.33768 14.9954 7.37936 15.0382C7.42103 15.0811 7.44444 15.1392 7.44444 15.1999Z" />
    </svg>
  `,
})
export class BulletListIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
}
